import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';
import Input from './Input';

const NewClientModal = ({ isOpen, onClose, onSave }) => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    address: ''
  });

  const [errors, setErrors] = useState({});

  if (!isOpen) return null;

  const handleInputChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
    if (errors?.[field]) {
      setErrors({ ...errors, [field]: '' });
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.name?.trim()) {
      newErrors.name = 'El nombre es requerido';
    }

    if (!formData?.phone?.trim()) {
      newErrors.phone = 'El teléfono es requerido';
    } else if (!/^[0-9-]+$/?.test(formData?.phone)) {
      newErrors.phone = 'Formato de teléfono inválido';
    }

    if (formData?.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/?.test(formData?.email)) {
      newErrors.email = 'Formato de email inválido';
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const handleSave = () => {
    if (validateForm()) {
      const newClient = {
        value: `${formData?.name?.toLowerCase()?.replace(/\s+/g, '_')}_${Date.now()}`,
        label: `${formData?.name} - ${formData?.phone}`,
        ...formData
      };
      onSave(newClient);
      setFormData({ name: '', phone: '', email: '', address: '' });
      setErrors({});
    }
  };

  const handleClose = () => {
    setFormData({ name: '', phone: '', email: '', address: '' });
    setErrors({});
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 z-[2100] flex items-center justify-center p-4 bg-black/50"
      onClick={handleClose}
    >
      <div 
        className="bg-card rounded-lg shadow-elevation-5 w-full max-w-md"
        onClick={(e) => e?.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 md:p-6 border-b border-border">
          <h2 className="text-lg md:text-xl font-semibold text-foreground">
            Nuevo Cliente
          </h2>
          <button
            onClick={handleClose}
            className="p-2 rounded-lg hover:bg-muted transition-smooth focus-ring"
            aria-label="Cerrar"
          >
            <Icon name="X" size={20} />
          </button>
        </div>

        <div className="p-4 md:p-6 space-y-4">
          <Input
            label="Nombre completo"
            type="text"
            value={formData?.name}
            onChange={(e) => handleInputChange('name', e?.target?.value)}
            required
            error={errors?.name}
            placeholder="Ej: Juan Pérez"
          />

          <Input
            label="Teléfono"
            type="tel"
            value={formData?.phone}
            onChange={(e) => handleInputChange('phone', e?.target?.value)}
            required
            error={errors?.phone}
            placeholder="Ej: 612-345-6789"
          />

          <Input
            label="Email"
            type="email"
            value={formData?.email}
            onChange={(e) => handleInputChange('email', e?.target?.value)}
            error={errors?.email}
            placeholder="Ej: cliente@ejemplo.com"
          />

          <Input
            label="Dirección"
            type="text"
            value={formData?.address}
            onChange={(e) => handleInputChange('address', e?.target?.value)}
            placeholder="Ej: Calle Principal #123"
          />
        </div>

        <div className="flex items-center justify-end gap-3 p-4 md:p-6 border-t border-border">
          <Button
            variant="outline"
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
          >
            <Icon name="Check" size={18} />
            Guardar Cliente
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NewClientModal;